import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "flex-grow-1 ms-2" }
const _hoisted_7 = { class: "fw-medium fs-16 mb-0" }
const _hoisted_8 = { class: "fs-18 fw-medium text-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-30" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Item By Category")
      ], -1)),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listItemCategory, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom list-item-category",
            key: item.name,
            onClick: ($event: any) => (_ctx.goToGroupCategory(item))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h6", _hoisted_7, _toDisplayString(item?.name), 1)
              ])
            ]),
            _createElementVNode("span", _hoisted_8, _toDisplayString(item?.total), 1)
          ], 8, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}